<div class="container">
  <div class="row">
    <div class="col-sm-12 text-center abx-rect-section">
      <div>
        <div class="abx-header-section">
          <h3 class="abx-header">{{'DoYouNeedHelp' | translate}}</h3>
          <br /><br />
          <div class="lead">{{'LearnMoreDesc' | translate}}</div>
          <div class="lead"><b><a href="https://www.scanwritr.com/">{{ 'LearnMore' | translate }}</a></b></div>
          <hr />
          <h3 class="abx-header"><b>{{ 'ContactSupport' | translate }}</b></h3>
          <br /><br />
          <div class="lead">{{'HelpDesc' | translate}}</div>
          <div class="lead"><b><a href="mailto:support@vanaia.com">support@vanaia.com</a></b></div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</div>
